module.exports = "/images/vendor/flag-icon-css/flags/4x3/py.svg?bbc22e414bad33de0d15531e95a2cf3f";